import React, { useContext } from "react";
import { Plan } from "../../@types";
import { AppStore } from "../../app/store";
import { makePlanDisplayId, useTranslate } from "../../helpers";
import { getPlanName } from "../../helpers/planHelpers";

export const SanctionedPlanCards: React.FC<{
  currentPage: Plan[];
}> = ({ currentPage }) => {
  const t = useTranslate();
  const {
    state: { language },
  } = useContext(AppStore.AppContext);
  return (
    <>
      {currentPage.map((plan: Plan) => {
        const key = `plan-name-${plan.name.replace(/\W/g, "-").toLowerCase()}`;
        const sanction = plan.redactions.find(
          red => red.type === "sanction" && red.url
        );
        const sanctionUrl =
          sanction?.url ??
          "https://www.cms.gov/Medicare/Compliance-and-Audits/Part-C-and-Part-D-Compliance-and-Audits/PartCandPartDEnforcementActions-";
        return (
          <li className="SanctionedPlanCard" key={key}>
            <div className="SanctionedPlanCard__summary">
              <h3 className="SanctionedPlanCard__planName">
                {getPlanName(plan, language)}
              </h3>
              <div className="SanctionedPlanCard__orgName">
                {plan.organization_name}
              </div>
              <div className="SanctionedPlanCard__planId">
                {makePlanDisplayId(plan)}
              </div>
              <div className="ds-u-margin-top--1 ds-u-margin-bottom--3">
                <a href={sanctionUrl} target="_blank" rel="noopener noreferrer">
                  {t("plan_terms.view_sanction_letter")}
                </a>
              </div>
            </div>

            <div className="SanctionedPlanCard__content">
              <div className="SanctionedPlanCard__heading">
                {t("plan_terms.contact_information")}
              </div>

              <address className="ds-u-font-style--normal">
                {plan.address_1}
                <br />
                {plan.address_2 && (
                  <>
                    {plan.address_2}
                    <br />
                  </>
                )}
                {plan.city}, {plan.state} {plan.zipcode}
              </address>

              {plan.member_phone && (
                <p className="SanctionedPlanCard__phoneNumber">
                  {t("plan_terms.members")}{" "}
                  <a
                    href={`tel:+${plan.member_phone.number}`}
                    className="ds-u-font-weight--normal"
                  >
                    {plan.member_phone.number}
                  </a>
                </p>
              )}

              {plan.prospect_phone && (
                <p className="SanctionedPlanCard__phoneNumber">
                  {t("plan_terms.non_members")}{" "}
                  <a
                    href={`tel:+${plan.prospect_phone.number}`}
                    className="ds-u-font-weight--normal"
                  >
                    {plan.prospect_phone.number}
                  </a>
                </p>
              )}

              <a
                href={`https://${plan.url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="ds-u-margin-bottom--3"
              >
                {t("plan_terms.view_plan_website")}
              </a>
            </div>
          </li>
        );
      })}
    </>
  );
};
